import PasswordForget from '../components/auth/password-forgot/PasswordForget';
 
const PagePasswordForget = () => (<PasswordForget/>);
export default PagePasswordForget;